import { useActivitySummaryContext } from '../../../../context'

export function useData() {
  const [{ activeTab, anchorEl, editActivityId, editStatusActivityId }] =
    useActivitySummaryContext()

  return { activeTab, anchorEl, editActivityId, editStatusActivityId }
}
